import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show } from "@clerk/react";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Landing from "@/pages/Landing";
import VenuePage from "@/pages/VenuePage";
import OrderStatus from "@/pages/OrderStatus";
import EventPage from "@/pages/EventPage";
import PassPage from "@/pages/PassPage";
import Legal from "@/pages/Legal";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";
import Dashboard from "@/pages/owner/Dashboard";
import StaffScreen from "@/pages/staff/StaffScreen";
import StaffJoin from "@/pages/staff/StaffJoin";
import AdminPanel from "@/pages/admin/AdminPanel";
import { AdminLogin, AdminSetup } from "@/pages/admin/AdminAuth";
import NotFound from "@/pages/NotFound";
import Pilot from "@/pages/Pilot";

const Protected = ({ children }) => (
  <>
    <Show when="signed-in">{children}</Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/v/:slug" element={<VenuePage />} />
            <Route path="/o/:orderId" element={<OrderStatus />} />
            <Route path="/e/:eventId" element={<EventPage />} />
            <Route path="/p/:regId" element={<PassPage />} />
            <Route path="/staff/join" element={<StaffJoin />} />
            <Route path="/staff/:slug" element={<StaffScreen />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/sign-in/*" element={<SignInPage />} />
            <Route path="/pilot" element={<Pilot />} />
            <Route path="/sign-up/*" element={<SignUpPage />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/setup" element={<AdminSetup />} />
            <Route path="/admin/*" element={<AdminPanel />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
